export const secondsToMs = (seconds) => {
    const minute = `0${Math.floor(seconds / 60)}`;
    const second = `0${Math.floor(seconds % 60)}`;
    return `${minute.substring(minute.length - 2)}:${second.substring(second.length - 2)}`;
};
//# sourceMappingURL=secondsToMs.js.map